import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type {
  TypeGetShippingLabelsShippingLabelIdParams,
  TypeGetShippingLabelsShippingLabelIdResponse,
} from '~/types/delivery-agency.types';

/**
 * [운송장 관리] 운송장 상세 조회 API
 */
const fetchShippingLabelsShippingLabelId = async (
  params: TypeGetShippingLabelsShippingLabelIdParams
): Promise<TypeGetShippingLabelsShippingLabelIdResponse['data']> => {
  const { data } = await axiosInstance.get<TypeGetShippingLabelsShippingLabelIdResponse>(
    `${API_ENDPOINT.DELIVERY_AGENCY.GET_SHIPPING_LABEL_DETAIL}/${params.shippingLabelId}`
  );
  return data.data;
};

/**
 * [운송장 관리] 운송장 상세 조회 Mutation Hook
 */
export const useGetShippingLabelsShippingLabelIdMutation = () => {
  return useMutation({
    mutationFn: fetchShippingLabelsShippingLabelId,
  });
};

/**
 * [운송장 관리] 운송장 상세 조회 Mock
 *
 * @remarks
 * DevTools에서 Mock을 활성화하면 응답합니다. `search-conditions` 등 하위 경로와 겹치지 않게 숫자 id 만 받는다.
 */
registerMockAPI<TypeGetShippingLabelsShippingLabelIdResponse>({
  method: 'get',
  endpoint: '/api-delivery-agency/shipping-labels/:id(\\d+)',
  label: '운송장 관리/운송장 상세',
  scenarios: [
    {
      name: '정상 응답 (배송 중)',
      response: {
        data: {
          outboundCode: 'JA9LAK0140003',
          orderInfo: {
            ordererName: '이*문',
            receiverName: '이*송',
            receiverContact: '010-****-3456',
            primaryAddress: '서울특별시 강남구 테헤란로 ***',
            secondaryAddress: '3**호',
            deliveryLocation: { code: 'DOORSTEP', description: '문 앞' },
            deliveryLocationDetail: '',
            entranceMethod: { code: 'PUBLIC_DOOR_PWD', description: '공동현관 비밀번호' },
            entranceMethodDetail: '#1234*',
          },
          productNames: ['탄산수 500ml x24', '제로 콜라 355ml x12'],
          shippingLabelInfo: {
            shippingLabelNumber: '210-C0-JA9LAK0140003-0001',
            status: { code: 'ON_THE_WAY', description: '배송 중' },
            statusUpdatedAt: '2026-05-19T08:20:00',
            deliveryType: { code: 'DAY', description: '하루배송' },
            courierCode: { code: 'LTT', description: '롯데' },
          },
        },
      },
    },
  ],
});
